/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = {
  userList: {}, // List of imported users
};

const getters = {
  userList(state) {
    return state.userList;
  },
};

const mutations = {
  updateUserList(state, userList) {
    state.userList = userList;
  },
};

const actions = {
  setUserList({ commit }, userList) {
    commit('updateUserList', userList);
  },
};

/**
 * export module to main store.js
 */
export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/importUsers.js